import React, { useState, useEffect } from 'react';
import { HiOutlineSearch } from 'react-icons/hi';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import cn from 'classnames';
import styles from './style.module.scss';

const SearchInput = ({
  handleSearchedValue,
  width,
  placeholder,
  reset,
  resetVal,
  searchVal,
  setSearchVal,
  validationReq,
  validations,
}) => {
  const formatSearch = () => {
    handleSearchedValue(searchVal);
  };

  useEffect(() => {
    resetVal && setSearchVal('');
  }, [resetVal]);

  //function to handle enter key
  const handleEnter = (event) => {
    let isValidated = validationReq ? validations(event.target.value) : true;
    if (event.keyCode === 13 && isValidated && searchVal) {
      formatSearch();
    }
  };

  const handleOnChange = (e) => {
    let isValidated = validationReq ? validations(e.target.value) : true;
    if (isValidated) {
      const cleanedValue = e.target.value.replace(/\s/g, '');
      setSearchVal(cleanedValue);
    }
  };

  return (
    <div className={styles.divContainer}>
      <div className={styles.inputDiv}>
        <input
          id="searchInput"
          type="text"
          className={styles.search_input}
          placeholder={placeholder}
          value={searchVal || ''}
          onChange={(e) => handleOnChange(e)}
          onKeyDown={(e) => handleEnter(e)}
        />
        {searchVal.length ? (
          <AiOutlineCloseCircle
            className={styles.closeIcon}
            stroke="#c4c4c4"
            aria-hidden="true"
            onClick={() => {
              setSearchVal('');
              reset && reset();
            }}
          />
        ) : (
          <div style={{ height: '16px', width: '16px' }}></div>
        )}
      </div>
      <div
        className={cn(styles.search_icon, !searchVal && styles.disable_search_icon)}
        onClick={() => (searchVal ? formatSearch() : null)}
      >
        <HiOutlineSearch className="w-20 h-20" stroke="#fff" aria-hidden="true" />
      </div>
    </div>
  );
};

export default SearchInput;
